import axios from "axios";
import { useQuery } from "react-query";
import { API_ENDPOINT } from "../constants/constants";
import { getHeader } from "../utility/utility";

const useApiEp = (path, enabled = true, retry = 1) => {
  const URL_EP = `${API_ENDPOINT}${path}`;
  return useQuery({
    queryKey: [URL_EP],
    queryFn: async () => {
      const response = await axios.get(URL_EP, getHeader());
      return response.data;
    },
    retry: retry,
    refetchOnWindowFocus: false,
    enabled: enabled,
  });
};

export default useApiEp;
